module.exports = __webpack_public_path__ + "static/kcdc2018-2-1f5b36f6b8e6742fb64cedcd93013b5a.jpeg";